import React, { Component } from "react";
import  { Breakpoint } from "react-socks";
import PagesComponentCompressed from "./select-accessories/PagesComponentCompressed";
import PagesComponentRegular from "./select-accessories/PagesComponentRegular";

export default class HomePage extends Component {
    render() {
        return (
            <>
                <Breakpoint small down>
                    <PagesComponentCompressed />
                </Breakpoint>
                <Breakpoint medium up>
                    <PagesComponentRegular />
                </Breakpoint>
            </>
        );
    }
}
